module.exports = __webpack_public_path__ + "media/images/categories/r-splash-meta-tag-25a1055d326431aef3a021ac707f65a5.png";